import { AxiosResponse } from 'axios';
import { axios } from '@repository/RequestClient';
import LicensesRs from '@domain/rs/profile/skill/LicenseRs';

export default interface LicensesRepo {
  //자격증 목록 조회
  fetchLicenses(keyword: string): Promise<AxiosResponse<LicensesRs>>;
}

export class RemoteLicensesRepo implements LicensesRepo {
  fetchLicenses(keyword: string) {
    return axios.get<LicensesRs>(`/licenses`, { params: { keyword } });
  }
}
